import React, { useEffect } from 'react';
import { useCreateUserWithEmailAndPassword, useSignInWithGoogle, useUpdateProfile } from "react-firebase-hooks/auth";
import auth from "../../firebase.init";
import { useForm } from "react-hook-form";
import Loading from "../Shared/Loading";
import { Link, useNavigate } from "react-router-dom";
import useToken from '../../hooks/useToken';


const SignUp = () => {
    const [signInWithGoogle, gUser, gLoading, gError] = useSignInWithGoogle(auth);
    const [
        createUserWithEmailAndPassword,
        user,
        loading,
        error,
      ] = useCreateUserWithEmailAndPassword(auth, {sendEmailVerification: true});
    const [updateProfile, updating, updateError] = useUpdateProfile(auth);

    const [token] = useToken(user || gUser);

    const navigate = useNavigate();
  
    const {register,formState: { errors },handleSubmit,} = useForm();
    let signInError;

    useEffect(()=>{
        if (token) {
              navigate('/');
            }
    },[token, navigate]);
  
    if (loading || gLoading || updating) {
      return <Loading></Loading>
    }
    if (error || gError || updateError) {
      signInError = <p className="text-red-500 text-sm">{error?.message || gError?.message ||updateError.message}</p>
    }
    const onSubmit =async(data) => {
      await createUserWithEmailAndPassword(data.email, data.password);
      await updateProfile({displayName: data.name});
    };
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="card w-full md:max-w-md bg-base-100 shadow-xl">
          <div className="card-body">
            <h2 className="text-center text-2xl font-bold">Sign Up</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text font-semibold">Name</span>
                </label>
                <input
                  type="text"
                  placeholder="Your Name"
                  className="input input-bordered w-full"
                  {...register("name", {
                    required: {
                      value: true,
                      message: "Name is Required"
                    }
                  })}
                />
                <label className="label">
                  {errors.name?.type === "required" && (
                    <span className="label-text-alt text-red-500">{errors.name.message}</span>
                  )}
                </label>
              </div>
              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text font-semibold">Email</span>
                </label>
                <input
                  type="email"
                  placeholder="Your Email"
                  className="input input-bordered w-full"
                  {...register("email", {
                    required: {
                      value: true,
                      message: "Email is Required"
                    },
                    pattern: {
                      value: /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/,
                      message: "Provide a valid Email"
                    }
                  })}
                />
                <label className="label">
                  {errors.email?.type === "required" && (
                    <span className="label-text-alt text-red-500">{errors.email.message}</span>
                  )}
                  {errors.email?.type === "pattern" && (
                    <span className="label-text-alt text-red-500">{errors.email.message}</span>
                  )}
                </label>
              </div>
              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text font-semibold">Password</span>
                </label>
                <input
                  type="password"
                  placeholder="Password"
                  className="input input-bordered w-full"
                  {...register("password", {
                    required: {
                      value: true,
                      message: "Password is Required"
                    },
                    minLength: {
                      value: 6,
                      message: 'Must be 6 characters or longer' 
                    }
                  })}
                />
                <label className="label">
                  {errors.password?.type === "required" && (
                    <span className="label-text-alt text-red-500">{errors.password.message}</span>
                  )}
                  {errors.password?.type === "minLength" && (
                    <span className="label-text-alt text-red-500">{errors.password.message}</span>
                  )}
                </label>
              </div>
              {signInError}
              <input className="btn w-full text-white" type="submit" value="Sign Up"/>
            </form>
            <p className="text-sm text-center">Already have an account? <Link className="text-secondary" to="/login"> Please Login</Link></p>
            <div className="divider">OR</div>
            <button onClick={() => signInWithGoogle()} className="btn btn-secondary uppercase text-white">
              Log In with Google
            </button>
          </div>
        </div>
      </div>
    );
};

export default SignUp;